import { TFunction } from 'i18next';

import {
  DataSetSeriesGenerator,
  getDefaultToolptipFormatter,
  PriceViewerSeries,
  TooltipFormatter,
} from './base';

class Concentration extends DataSetSeriesGenerator {
  isSeparateFromPriceChart = false;
  shareYAxisWithPriceChart = false;
  height = -1;

  topN: number;
  accessor: string;
  tooltipFormatter: TooltipFormatter;
  colorStyle: string;

  constructor(topN: number, t: TFunction, colorStyle: string) {
    super(t);
    this.topN = topN;
    this.accessor = `top${this.topN}concen`;
    this.colorStyle = colorStyle;
    this.tooltipFormatter = getDefaultToolptipFormatter(
      { accessor: this.accessor },
      'percentage',
      {
        keyColor: this.colorStyle,
        valueColor: this.colorStyle,
      }
    );
  }

  getChartName(): string {
    return this.t('Top N Concentration').replace('N', this.topN.toString());
  }

  getSeries(): PriceViewerSeries {
    return {
      name: this.getChartName(),
      echartSeries: {
        type: 'line',
        encode: {
          x: 'date',
          y: [this.accessor],
        },
        symbol: 'none',
        lineStyle: {
          color: this.colorStyle,
        },
      },
      legendColor: this.colorStyle,
      legendTextField: this.accessor,
      legendFormat: 'percentage',
      tooltipFormatter: this.tooltipFormatter,
    };
  }
}

export default Concentration;
